import React, {createContext, useContext} from "react"

const initialState = {

}

export const ClubComplaintManagerContext = createContext(initialState)

export const ClubComplaintManagerProvider = (props) => {



    const value = {
    }

    return (
        <ClubComplaintManagerContext.Provider value={value}>
            {props.children}
        </ClubComplaintManagerContext.Provider>
    )
}

export const useClubComplaintManagerContext = () => {
    const context = useContext(ClubComplaintManagerProvider)
    if (!context) {
        throw new Error('ComplaintManagerContext must be used within a ComplaintManagerProvider')
    }
    return context
}


// WEBPACK FOOTER //
// ./src/containers/ClubComplaintManager/store/useClubComplaintManagerContext.js